import { Heading } from '@/components/heading';
import { PackHeroVariant } from '@/utils/constants';
import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import { MediaImage } from '@calm/evexia-web-sdk';
import { AccessCodeHeader } from '@rhg/components/access-code-header';
import {
    FullPageFullWidthContainer,
    FullPagePaddedContainer,
    fullPagePaddingPx,
} from '@rhg/components/full-page-container';
import { Box, Theme } from '@rhg/libs/material';
import { ComponentProps, ReactNode } from 'react';
import { PackDetailsHeader } from '../header';

interface PackDetailsLayoutProps {
    children?: ReactNode;
    packClass?: string;
    title?: string;
    subtitle?: string;
    imageData?: MediaImage;
    reversed?: boolean;
    subtitleAlign?: ComponentProps<typeof Heading>['subtitleAlign'];
    spacing?: ComponentProps<typeof Heading>['spacing'];
    heroVariant?: PackHeroVariant;
}

const styleBackground = {
    minHeight: `calc(100dvh - ${DS_HEIGHT.TOOLBAR}px)`,
    pb: (theme: Theme) => theme.ds.spacingUnits.SECTION,
    position: 'relative',
};

export const PackDetailsPaddingPx = fullPagePaddingPx;
export const PackDetailsPaddedContainer = FullPagePaddedContainer;
export const PackDetailsFullWidthContainer = FullPageFullWidthContainer;

export const PackDetailsLayout = ({
    title,
    subtitle,
    imageData,
    reversed,
    subtitleAlign,
    spacing,
    heroVariant,
    children,
}: PackDetailsLayoutProps) => {
    return (
        <Box sx={styleBackground}>
            <AccessCodeHeader />

            <PackDetailsHeader
                title={title}
                subtitle={subtitle}
                imageData={imageData}
                reversed={reversed}
                subtitleAlign={subtitleAlign}
                spacing={spacing}
                heroVariant={heroVariant}
            />
            {children}
        </Box>
    );
};
